/* app/js/src/components/graphics/edit/fields/text-font.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.row:not(:first-child) {
  margin-top: 24px;
}
label {
  color: #7d8fa1;
  font-size: 12px;
  letter-spacing: 0.1px;
  margin-right: 10px;
}
.row.font-name icn-dropdown {
  margin-right: 24px;
}
.row.font-name icn-number-input {
  width: 110px;
}
.checkbox-input {
  padding: 0px 10px 7px 20px;
}
.checkbox-input div {
  position: relative;
  border: 1px solid #e1e6eb;
  width: 14px;
  height: 14px;
  cursor: pointer;
  margin-top: 6px;
  background-color: white;
}
.checkbox-input div svg {
  width: 10px;
  height: 7px;
  position: absolute;
  top: -1px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  fill-opacity: 0;
}
.checkbox-input.active div svg {
  fill-opacity: 1;
}
.shrink-to-fit-label {
  line-height: 32px;
  font-family: "Open Sans";
  font-size: 12px;
  color: #232f3a;
}
/*# sourceMappingURL=text-font.component.css.map */
